import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import DontLeave from "app/pages/.shared/DontLeave";
import Page from "app/pages/.shared/Page/Page";
import RelativeLink from "app/pages/.shared/RelativeLink";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { sendTagOnPageNotFound } from "app/utils/analytics";
import { getFallbackRedirectUrl } from "app/reducers/partnerSelector";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./NotFound.scss";

const NotFound = ({ fallbackRedirectUrl }) => {
	useEffect(() => {
		sendTagOnPageNotFound();
	}, []);

	return (
		<div className="not-found">
			<Page title={<FormattedMessage id="not.found.title" />}>
				<HeadMetadata page="404" />
				<div className="not-found__intro">
					<FormattedMessage id="not.found.message" />
					<DontLeave>
						<RelativeLink
							to={{ pathname: fallbackRedirectUrl }}
							variant="primary"
							enableLoading
							data-testid="confirm-leave-link"
						>
							<FormattedMessage id="confirmation.leave.button" />
						</RelativeLink>
					</DontLeave>
				</div>
			</Page>
		</div>
	);
};

NotFound.propTypes = {
	fallbackRedirectUrl: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
	};
};

export default connect(mapStateToProps)(NotFound);
